import { ValueOfKey } from '../../utils-types';
import { BillingPeriodType } from '../../payment/constants/billingPeriodType';
import { ScanIqSubscriptionType } from '../../shared/constants/user-info/subscription';

export const SETUP_STATUS = {
  NEED_SETUP: 'NEED_SETUP',
  COMPLETED: 'COMPLETED',
  DELETED: 'DELETED',
} as const;

export type SetupStatus = ValueOfKey<typeof SETUP_STATUS>;

// DELETED customers have no tab on the dashboard
export type SetupStatusTab = Exclude<SetupStatus, typeof SETUP_STATUS.DELETED>;

/*
  Customer state within the self-setup / challenge sign-up flow (2FA verify-code and
  personal-data update responses). Backend omits null fields from the JSON, so every
  field not guaranteed by the flow is absent rather than null.
*/
export type ScanIqCustomerSetupInfo = {
  id: number;
  entityId: number;
  setupStatus: SetupStatus;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  dateOfBirth?: string;
  gender?: string;
  height?: number;
  inbodyId?: string;
  inbodyUserToken?: string;
  activeSubscription?: ScanIqCustomerSubscription;
};

export type ScanIqCustomerSetupPersonalData = {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  dateOfBirth: string;
  gender: string;
  height: number;
  entityId: number;
};

type ScanIqCustomerSubscription = {
  billingPeriodType: BillingPeriodType;
  id: number;
  name: string;
  subscriptionType: ScanIqSubscriptionType;
};
